export default {"src":"/static/spa/fresh-spa/_next/static/media/pet-parents-like-you-badge.992f1656.svg","height":180,"width":177,"blurWidth":0,"blurHeight":0};